import { getEmptyAddress } from "@/lib/helper"
import { UserData } from "@/lib/intershop/interfaces/user/user"
import { ExtendedAddressRO } from "@/lib/storefront/addresses/address"
import AddressEditSheet from "@/components/common/addresses/AddressEditSheet"

interface AddAddressButtonProps {
  customer: any
  user: any
  onAdd: (address: ExtendedAddressRO, user: UserData) => void
  type: "invoiceTo" | "shipTo" | "general"
  addButtonLabel?: string
  context?: string
}

export default function AddAddressButton({
  customer,
  user,
  onAdd,
  type,
  addButtonLabel,
  context,
}: AddAddressButtonProps) {
  const handleSave = (newAddress: ExtendedAddressRO, newUser: UserData) => {
    onAdd(newAddress, newUser)
  }

  const emptyAddress = getEmptyAddress(type)

  return (
    <>
      <AddressEditSheet
        address={emptyAddress}
        customer={customer}
        user={user}
        mode={"add"}
        addButtonLabel={addButtonLabel}
        context={context}
        onSave={handleSave}
        type={type}
      />
      {/*      <AddressEditModal
        visible={modalVisible}
        address={addressToAdd}
        customer={customer}
        user={user}
        mode="add"
        onCancel={() => setModalVisible(false)}
        onSave={handleSave}
      />*/}
    </>
  )
}
